<div class="w-full h-full relative">
  <df-base-left-side-navigation
    *ngIf="!basePanelService.routeData?.hideLeftNavigation && !xPartnerService.isWhitelabelPartner"
    [class.short]="basePanelService.routeData.shortLeftNavigation"
  ></df-base-left-side-navigation>
  <div
    class="base-panel-content"
    [ngClass]="{
      'base-panel-content--hidden-side-navigation':
        basePanelService.routeData.hideLeftNavigation || xPartnerService.isWhitelabelPartner,
      'base-panel-content--hidden-header': basePanelService.routeData.hideHeader,
      'base-panel-content--short-navigation': basePanelService.routeData.shortLeftNavigation
    }"
  >
    <div
      class="base-panel-content__header"
      [class.short]="basePanelService.routeData.shortLeftNavigation"
      [class.full]="xPartnerService.isWhitelabelPartner"
      *ngIf="!basePanelService.routeData?.hideHeader"
    >
      <df-base-header></df-base-header>
    </div>
    <div
      class="base-panel-content__container relative"
      #basePanelContent
    >
      <df-base-onboarding-loading *ngIf="onboardingService.loading$ | async"></df-base-onboarding-loading>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<df-get-response-chat
  (close)="closeChat($event)"
  [ngClass]="{ '-left-96': closed }"
>
</df-get-response-chat>
<df-novu-notifications [ngClass]="{ hidden: !visibleNovuNotification }"></df-novu-notifications>

<df-memory-log></df-memory-log>
